import {
  TEAM_CHAT_AVATAR_BADGE_BORDER_WIDTH,
  TEAM_CHAT_AVATAR_BADGE_SIZE,
  TEAM_CHAT_AVATAR_BORDER_WIDTH,
  TEAM_CHAT_AVATAR_SMALL_THRESHOLD,
} from './TeamChatMemberAvatar.constants';

export const getWrapperStyles = ({ size }) => ({
  position: 'relative',
  display: 'inline-flex',
  width: `${size}px`,
  height: `${size}px`,
  flexShrink: 0,
});

export const getAvatarStyles = ({ size, color }) => ({
  width: `${size}px`,
  height: `${size}px`,
  border: `${TEAM_CHAT_AVATAR_BORDER_WIDTH}px solid`,
  borderColor: ({ palette }) => color?.bg || palette.grey[300],
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.secondary,
});

const getBadgeBaseStyles = ({ size }) => ({
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: `${TEAM_CHAT_AVATAR_BADGE_SIZE}px`,
  height: `${TEAM_CHAT_AVATAR_BADGE_SIZE}px`,
  borderRadius: '50%',
  border: `${TEAM_CHAT_AVATAR_BADGE_BORDER_WIDTH}px solid`,
  borderColor: ({ palette }) => palette.background.primary,
  zIndex: 1,
  transform: size < TEAM_CHAT_AVATAR_SMALL_THRESHOLD ? 'translate(20%, 20%)' : 'none',
});

export const getOnlineBadgeStyles = ({ size }) => ({
  ...getBadgeBaseStyles({ size }),
  backgroundColor: ({ palette }) => palette.success.main,
});

export const getOfflineBadgeStyles = ({ size }) => ({
  ...getBadgeBaseStyles({ size }),
  backgroundColor: ({ palette }) => palette.grey[400],
});
